import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

// Handles Emergent OAuth callback: reads #session_id=... from URL, exchanges with backend, sets auth.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google", { session_id });
        // Clean URL fragment before navigating
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        setAuth(data.token, data.user);
        toast.success(`Welcome, ${data.user.name || data.user.email}`);
        const nextParam = new URLSearchParams(window.location.search).get("next");
        navigate(nextParam || "/account", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-rw-bg text-rw-ink2" data-testid="auth-callback-page">
      <div className="font-display text-xl animate-pulse">Finishing sign-in…</div>
    </div>
  );
}
